var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_236_5683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6259 18.627 23.9981 11.9971 23.999C5.37206 23.999 -0.000959639 18.6259 5.14575e-07 11.999C-0.00191979 5.37216 5.3711 0 11.999 0C18.627 0 24 5.37312 24 12Z",
    fill: "#9CB7D4",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_236_5683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.12476 12.7939V10.5137",
    stroke: "#27313D",
    strokeWidth: 0.80914,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16259 8.34414C6.28305 7.54475 6.68571 6.81515 7.29742 6.28789C7.90913 5.76063 8.6893 5.47068 9.49624 5.4707H15.158C15.6007 5.4707 16.0391 5.55807 16.4481 5.72782C16.8571 5.89758 17.2287 6.14638 17.5417 6.46004C17.8547 6.77369 18.103 7.14605 18.2724 7.55584C18.4417 7.96564 18.5289 8.40485 18.5288 8.84839V14.5208C18.5288 14.9643 18.4416 15.4034 18.2722 15.8132C18.1028 16.2229 17.8545 16.5952 17.5415 16.9088C17.2285 17.2224 16.8569 17.4712 16.4479 17.6409C16.039 17.8106 15.6006 17.898 15.158 17.898H9.49624C8.68688 17.898 7.90453 17.6063 7.29209 17.0762C6.67965 16.546 6.278 15.8129 6.16052 15.0106",
    stroke: "#27313D",
    strokeWidth: 0.80914,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4058 14.6994C14.0821 14.6994 15.4411 13.3379 15.4411 11.6584C15.4411 9.97894 14.0821 8.61743 12.4058 8.61743C10.7294 8.61743 9.37048 9.97894 9.37048 11.6584C9.37048 13.3379 10.7294 14.6994 12.4058 14.6994Z",
    stroke: "#27313D",
    strokeWidth: 0.719137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4059 12.498C12.8683 12.498 13.2432 12.1225 13.2432 11.6592C13.2432 11.1959 12.8683 10.8203 12.4059 10.8203C11.9435 10.8203 11.5686 11.1959 11.5686 11.6592C11.5686 12.1225 11.9435 12.498 12.4059 12.498Z",
    fill: "#27313D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4052 8.61743V11.6584L15.0187 13.2053",
    stroke: "#27313D",
    strokeWidth: 0.584355,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79138 13.2051L12.4049 11.6582",
    stroke: "#27313D",
    strokeWidth: 0.584355,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85197 8.51172H5.3396V10.3472H7.85197V8.51172Z",
    stroke: "#27313D",
    strokeWidth: 0.584355,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85197 12.9688H5.3396V14.8042H7.85197V12.9688Z",
    stroke: "#27313D",
    strokeWidth: 0.584355,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2333 18.1367C10.2331 18.2899 10.1723 18.4369 10.064 18.5452C9.95582 18.6535 9.80911 18.7143 9.65613 18.7143H8.45493C8.30195 18.7143 8.15524 18.6535 8.04702 18.5452C7.93881 18.4369 7.87794 18.2899 7.87781 18.1367V17.7969",
    stroke: "#27313D",
    strokeWidth: 0.494352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6186 17.793V18.1353C16.6185 18.2886 16.5576 18.4355 16.4494 18.5439C16.3412 18.6522 16.1945 18.713 16.0415 18.713H14.8403C14.6873 18.713 14.5406 18.6522 14.4324 18.5439C14.3242 18.4355 14.2633 18.2886 14.2632 18.1353",
    stroke: "#27313D",
    strokeWidth: 0.494352,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_236_5683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_236_5683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVault);
export default __webpack_public_path__ + "static/media/vault.2787a6ae5bdb1be4b7c65e501137d51e.svg";
export { ForwardRef as ReactComponent };